var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"splash"},[_c('img',{staticClass:"splash",attrs:{"alt":"","src":_vm.$route.params.imageUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }